import reducer from './reducers';

export { default as Dashboard } from './containers';

export default reducer;
